module.exports = __webpack_public_path__ + "img/74.ae42625a.jpg";